import Link from '@/links';
import {useTranslations} from 'next-intl';
import {withBoldWeight} from '@/hocs/withFontType';

const BoldSpan = withBoldWeight('span');

const AdBannerCopy = () => {
  const t = useTranslations('shared.adBanner');

  return (
    <div>
      <img src="/static/images/ad-banner/AI-agent-logo.svg" alt="" aria-hidden />
      <BoldSpan>{t('description')}</BoldSpan>
      <Link
        variant="ribbon-purple"
        href="/workable-ai"
        customAttributes={{'data-ui': 'banner-link'}}>
        {t('button')}
      </Link>
    </div>
  );
};

export default AdBannerCopy;
